import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';

const useInquiries = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [inquiries, setInquiries] = useState<any[]>([]);

  useEffect(() => {
    const fetchInquiries = async () => {
      setLoading(true);
      try {
        const res = await DAV_APIS.inquiries.getInquiries();
        setInquiries(res.data.data);
        setLoading(false);
      } catch (error: any) {
        if (error.response?.status === 404) {
          setInquiries([]);
        }
        setLoading(false);
      }
    };

    fetchInquiries();
  }, []);

  return {
    loading,
    inquiries,
  };
};

export default useInquiries;